export const NEW_MESSAGE_ADD = "NEW_MESSAGE_ADD";
